import React from 'react';

import {withCssModule} from '@pb/kit-util-with-css-module';

import styles from './popover.module.styl';

import type {ComponentPropsWithoutRef} from 'react';

const classNames = withCssModule(styles);

type NativeProps = ComponentPropsWithoutRef<'div'>;

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface PopoverHeaderProps extends NativeProps {}

/**
 * Popover Header
 *
 * https://storybook.dev.pitchbookdata.com/?path=/docs/hover-popover--documentation
 */
export function PopoverHeader(props: PopoverHeaderProps) {
    return (
        <div
            {...props}
            className={classNames('popover-header', props.className)}
        />
    );
}
